const emitUserEvent = () => void 0;

export { emitUserEvent };
